import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import { FusePageSimple, DemoContent, TextFieldFormsy, CheckboxFormsy, RadioGroupFormsy, SelectFormsy } from '@fuse';
import Formsy from 'formsy-react';
import { Button, FormControlLabel, TextField, Hidden, MenuItem, Radio, Icon, Checkbox, Typography, IconButton, AppBar, Toolbar } from 'material-ui';
import ReactTable from "react-table";
import axios from 'axios';
import { bindActionCreators } from 'redux';
import Dialog, {
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from 'material-ui/Dialog';

import Scrollbar from "perfect-scrollbar-react";
import classNames from "classnames";
import "perfect-scrollbar-react/dist/style.min.css";
import "react-table/react-table.css";
import Select from 'react-select';
import Loader from "other-components/loader/loader";
import Tooltip from 'material-ui/Tooltip';
import { withAlert } from 'react-alert';
import { confirmAlert } from 'react-confirm-alert'; // Import
import printjs from 'print-js';
import CloseIcon from '@material-ui/icons/Close';
import moment from 'moment';
import { totalmem } from 'os';


const styles = theme => ({
    layoutRoot: {},
    layoutToolbar: {
        padding: 0
    },
    tabsRoot: {
        height: 64
    },
    tabRoot: {
        height: 64
    },
    smaller: {
        width: 30,
        height: 20,
    }
});


class CashBookReport extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            fromDate: moment(new Date()).format("YYYY-MM-DD"),
            toDate: moment(new Date()).format("YYYY-MM-DD"),
            cashBookCredits: [],
            cashBookDebits: []
        };
    }

    handleTextBoxChange = name => event => {
        this.setState({ [name]: event.target.value });
    };

    handleViewClick() {
        if (!this.state.fromDate || !this.state.toDate
            || this.state.fromDate == '' || this.state.toDate == '') {
            return this.props.alert.error('Select Date Range');
        }

        var reqBody = {
            fromDate: this.state.fromDate,
            toDate: this.state.toDate
        };
        const request = axios.post(window.accountServer + '/cashBook/getCashBookRecords', reqBody);
        this.setState({ loading: true });
        request.then((response) => {
            if (response.data && !response.data.eroor && response.data.success) {
                console.log('Cash Book Data', response);

                const cashBookDebits = response.data.result.debits;
                const cashBookCredits = response.data.result.credits;

                this.setState({
                    cashBookCredits: cashBookDebits,
                    cashBookDebits: cashBookCredits,
                    loading: false,
                });
            }
            else {
                console.log('Cash Book Fetch Error', response);
                this.props.alert.error('Data Fetch Error');
                this.setState({ loading: false });
            }
        })
            .catch((error) => {
                console.log('Cash Book Fetch Error', error);
                this.setState({ loading: false });
                this.props.alert.error('Data Fetch Error');
            });
    };

    handlePrintClick() {
        if (!this.state.fromDate || !this.state.toDate
            || this.state.fromDate == '' || this.state.toDate == '') {
            return this.props.alert.error('Select Date Range');
        }

        var path = null;
        axios.post(window.reportServer + '/cashBookReport/getCashBookReport',
        // axios.post('http://localhost:5008/cashBookReport/getCashBookReport',
            {
                fromDate: this.state.fromDate,
                toDate: this.state.toDate
            }
        )
            .then(response => {
                path = response.data.path;
                path = window.reportServer + "/" + path;
                // path = "http://localhost:5008/" + path;

                const url = path;
                window.open(url, '_blank');
            }).catch(function (error) {

                console.log("fsdddddddddddddddddd " + error);
                this.setState({ loading: false });
            });
    }

    getCreditTotal(cashOrBank) {
        var data = this.state.cashBookCredits;
        var total = 0.00;
        for (let i = 0; i < data.length; i++) {
            var val = 0.00;
            if (cashOrBank == 'CASH') {
                if (data[i].CASH != null) {
                    val = data[i].CASH;
                }
            }
            else {
                if (data[i].BANK != null) {
                    val = data[i].BANK;
                }
            }
            total = total + val;
        }
        return total;
    }

    getDebitTotal(cashOrBank) {
        var data = this.state.cashBookDebits;
        var total = 0.00;
        for (let i = 0; i < data.length; i++) {
            var val = 0.00;
            if (cashOrBank == 'CASH') {
                if (data[i].CASH != null) {
                    val = data[i].CASH;
                }
            }
            else {
                if (data[i].BANK != null) {
                    val = data[i].BANK;
                }
            }
            total = total + val;
        }
        return total;
    }

    render() {
        if (this.state.loading) {
            return (
                <Loader />
            );
        } else {
            return (
                <div>
                    <div className="p-8">
                        <h2 className="subtitle-color invoice-margin">Cash Book</h2>
                    </div>

                    <div className="p-8">
                        <TextField
                            id="name"
                            className="inline-block w-1/5 -mt-8"
                            //className={classes.textField}
                            /* classes={{
                                input: classes.input
                            }} */
                            label="From Date"
                            placeholder=""
                            type="date"
                            value={this.state.fromDate}
                            onChange={this.handleTextBoxChange('fromDate')}
                        />
                        <TextField
                            id="name"
                            className="inline-block w-1/5 -mt-8"
                            //className={classes.textField}
                            /* classes={{
                                input: classes.input
                            }} */
                            label="To Date"
                            placeholder=""
                            type="date"
                            value={this.state.toDate}
                            onChange={this.handleTextBoxChange('toDate')}
                        />

                    </div>

                    <DialogActions className="justify-right pl-16">
                        <Button
                            variant="raised"
                            color="secondary"
                            className="px-40 mx-16"
                            onClick={
                                (ev) => {
                                    ev.stopPropagation();
                                    this.handleViewClick();
                                }
                            }
                        >
                            View
                    </Button>
                        <Button
                            variant="raised"
                            color="secondary"
                            className="px-40 mx-16"
                            onClick={
                                (ev) => {
                                    ev.stopPropagation();
                                    this.handlePrintClick();
                                }
                            }
                        >
                            Print
                    </Button>
                    </DialogActions>
                    <div className="p-8 w-full">
                        <div className="p-4 w-1/2 inline-block">
                            <h3>Debit</h3>
                            <ReactTable
                                data={this.state.cashBookDebits}
                                columns={[

                                    {
                                        Header: "Account",
                                        accessor: "NAME"
                                    },
                                    {
                                        Header: "DATE",
                                        accessor: "DATE",
                                        Cell: row => (
                                            <div align="right" className="w-full">
                                                {row.original.DATE == null ? '' : moment(new Date(row.original.DATE)).format("YYYY-MM-DD")}
                                            </div>
                                        )
                                    },
                                    {
                                        Header: "CASH",
                                        accessor: "CASH",
                                        Cell: row => (
                                            <div align="right" className="w-full">
                                                {row.original.CASH == null ? '0.00' : parseFloat(row.original.CASH).toFixed(2)}
                                            </div>
                                        ),
                                        Footer: (
                                            <span>
                                                <div align="right" className="w-full">
                                                    <strong>
                                                        {parseFloat(this.getDebitTotal('CASH')).toFixed(2)}
                                                    </strong>
                                                </div>
                                            </span>
                                        )
                                    },
                                    {
                                        Header: "BANK",
                                        accessor: "CASH",
                                        Cell: row => (
                                            <div align="right" className="w-full">
                                                {row.original.BANK == null ? '0.00' : parseFloat(row.original.BANK).toFixed(2)}
                                            </div>
                                        ),
                                        Footer: (
                                            <span>
                                                <div align="right" className="w-full">
                                                    <strong>
                                                        {parseFloat(this.getDebitTotal('BANK')).toFixed(2)}
                                                    </strong>
                                                </div>
                                            </span>
                                        )
                                    }
                                ]}
                                pageSize={10}
                                //defaultPageSize={10}
                                className="-striped -highlight"
                            />
                        </div>
                        <div className="p-4 w-1/2 inline-block">
                            <h3>Credit</h3>
                            <ReactTable
                                data={this.state.cashBookCredits}
                                columns={[

                                    {
                                        Header: "Account",
                                        accessor: "NAME"
                                    },
                                    {
                                        Header: "DATE",
                                        accessor: "DATE",
                                        Cell: row => (
                                            <div align="right" className="w-full">
                                                {row.original.DATE == null ? '' : moment(new Date(row.original.DATE)).format("YYYY-MM-DD")}
                                            </div>
                                        )
                                    },
                                    {
                                        Header: "CASH",
                                        accessor: "CASH",
                                        Cell: row => (
                                            <div align="right" className="w-full">
                                                {row.original.CASH == null ? '0.00' : parseFloat(row.original.CASH).toFixed(2)}
                                            </div>
                                        ),
                                        Footer: (
                                            <span>
                                                <div align="right" className="w-full">
                                                    <strong>
                                                        {parseFloat(this.getCreditTotal('CASH')).toFixed(2)}
                                                    </strong>
                                                </div>
                                            </span>
                                        )
                                    },
                                    {
                                        Header: "BANK",
                                        accessor: "CASH",
                                        Cell: row => (
                                            <div align="right" className="w-full">
                                                {row.original.BANK == null ? '0.00' : parseFloat(row.original.BANK).toFixed(2)}
                                            </div>
                                        ),
                                        Footer: (
                                            <span>
                                                <div align="right" className="w-full">
                                                    <strong>
                                                        {parseFloat(this.getCreditTotal('BANK')).toFixed(2)}
                                                    </strong>
                                                </div>
                                            </span>
                                        )
                                    }
                                ]}
                                pageSize={10}
                                //defaultPageSize={10}
                                className="-striped -highlight"
                            />
                        </div>
                    </div>
                </div>
            )
        }

    }

    componentWillMount() {

    }

}

export default withStyles(styles, { withTheme: true })(withAlert(CashBookReport));










// WEBPACK FOOTER //
// ./src/main/content/accountingReports/cashBookReport/cashBookReport.js